export default {
  namespaced: true,
  state: {
    VendorIntroVideo: {
      show: false,
    },
    VariantChooser: {
      selectedProperties: [],
      variants: [],
      chosenVariant: null,
    },
    OtherVendorsModal: {
      show: false
    }
  },
  getters: {
    showVendorIntroVideo: state => {
      return state.VendorIntroVideo.show;
    },
    selectedProperties: state => {
      return state.VariantChooser.selectedProperties;
    },
    allProductVariants: state => {
      return state.VariantChooser.variants;
    },
    chosenVariant: state => {
      return state.VariantChooser.chosenVariant;
    },
    showOtherVendorsModal: state => {
      return state.OtherVendorsModal.show
    }
  },
  actions: {
    setVendorIntroShow: (context, data) => {
      context.commit("setVendorIntroVideoShow", data);
    },
    setSelectedProperties: (context, variant) => {
      context.commit("setSelectedProperties", variant);
    },
    setProductVariants: (context, variants) => {
      context.commit("setProductVariants", variants);
    },
    emptySelectedProperties: context => {
      context.commit("emptySelectedProperties");
    },
    setChosenVariant: (context, variantId) => {
      context.commit("setChosenVariant", variantId);
    },
    showOtherVendorsModal: (context, data) => {
      context.commit("showOtherVendorsModal", data)
    }
  },
  mutations: {
    setVendorIntroVideoShow: (state, bool) => {
      state.VendorIntroVideo.show = bool;
    },
    resetSelectedProperties: state => {
      state.VariantChooser.selectedProperties = [];
    },
    setSelectedProperties: (state, property) => {
      const selectedProperties = state.VariantChooser.selectedProperties;

      selectedProperties.forEach((stateProperty, index) => {
        if (stateProperty.key === property.key) {
          state.VariantChooser.selectedProperties.splice(index, 1);
        }
      });

      state.VariantChooser.selectedProperties.push(property);
    },
    setProductVariants: (state, variants) => {
      state.VariantChooser.variants = variants;
    },
    emptySelectedProperties: state => {
      state.VariantChooser.selectedProperties = [];
    },
    setChosenVariant: (state, variantId) => {
      state.VariantChooser.chosenVariant = variantId;
    },
    showOtherVendorsModal: (state, bool) => {
      state.OtherVendorsModal.show = bool
    }
  },
};
